<template>
  <span>
    <!-- grid search -->
    <v-row>
      <v-col :cols="disabled ? 12:6">
        <v-text-field
          v-model="keyword"
          append-icon="mdi-magnify"
          label="Cari"
          hide-details
          single-line
          clearable
        ></v-text-field>
      </v-col>
      <!-- form rincian transaksi -->
      <v-col cols="6" class="text-right" v-if="!disabled">
        <v-btn class="ml-2 mt-2" color="primary" outlined @click="addItem">
          <span class="hidden-xs-only">Tambah</span>
          <v-icon :right="!$vuetify.breakpoint.xsOnly">mdi-plus-box</v-icon>
        </v-btn>
        <v-dialog v-model="dialog" persistent max-width="400px">
          <ValidateAll ref="form">
            <v-form>
              <v-card>
                <v-card-title>Rincian Anggaran</v-card-title>
                <v-divider></v-divider>
                <v-card-text class="dialog-form">
                  <v-row>
                    <v-col cols="12">
                      <Validate name="Jenis transaksi" rules="fully_required" #default="{ errors }">
                        <v-select
                          :error-messages="errors"
                          hide-details="auto"
                          v-model="item.Jenis"
                          :items="list.jenisTransaksi"
                          @input="changeJenisTransaksi"
                          label="Jenis Transaksi"
                        >
                          <template v-slot:selection="{ item }">
                            <v-icon
                              v-text="item.value == 'penerimaan' ? 'mdi-wallet':'mdi-cart'"
                              small
                              left
                            ></v-icon>
                            <span>{{item.text}}</span>
                          </template>
                        </v-select>
                      </Validate>
                    </v-col>
                  </v-row>
                  <v-row v-if="item.Jenis=='belanja'">
                    <v-col cols="12">
                      <Validate name="Program" rules="fully_required" #default="{ errors }">
                        <v-autocomplete
                          :error-messages="errors"
                          hide-details="auto"
                          v-model="item.Program"
                          :items="list.program.data"
                          :loading="isProgramLoading"
                          :filter="filterProgram"
                          item-text="Nama"
                          item-value="IDProgram"
                          hide-no-data
                          label="Program"
                          @input="changeProgram"
                          placeholder="Pencarian Program"
                          clearable
                          return-object
                        >
                          <template v-slot:selection="data">
                            <div class="text--secondary caption mb-n2 mt-2">{{data.item.Kode}}</div>
                            <v-list-item-title>{{data.item.Nama}}</v-list-item-title>
                          </template>
                          <template v-slot:item="data">
                            <template v-if="typeof data.item !== 'object'">
                              <v-list-item-content v-text="data.item"></v-list-item-content>
                            </template>
                            <template v-else>
                              <v-list-item-content>
                                <v-list-item-title class="py-0">
                                  {{data.item.Nama}}
                                  &mdash;
                                  <span
                                    class="text--secondary"
                                  >{{data.item.Kode}}</span>
                                </v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </template>
                        </v-autocomplete>
                      </Validate>
                    </v-col>
                  </v-row>
                  <v-row v-if="item.Jenis=='belanja'">
                    <v-col cols="12">
                      <Validate name="Kegiatan" rules="fully_required" #default="{ errors }">
                        <v-autocomplete
                          :error-messages="errors"
                          hide-details="auto"
                          v-model="item.Kegiatan"
                          :items="list.kegiatan.data"
                          :loading="isKegiatanLoading"
                          :filter="filterKegiatan"
                          item-text="Nama"
                          item-value="IDKegiatan"
                          hide-no-data
                          label="Kegiatan"
                          :placeholder="isProgramEmpty? 'Pilih Program Terlebih Dahulu':'Pencarian Kegiatan'"
                          :disabled="isProgramEmpty"
                          clearable
                          return-object
                        >
                          <template v-slot:selection="data">
                            <div class="text--secondary caption mb-n2 mt-2">{{data.item.Kode}}</div>
                            <v-list-item-title>{{data.item.Nama}}</v-list-item-title>
                          </template>
                          <template v-slot:item="data">
                            <template v-if="typeof data.item !== 'object'">
                              <v-list-item-content v-text="data.item"></v-list-item-content>
                            </template>
                            <template v-else>
                              <v-list-item-content>
                                <v-list-item-title class="py-0">
                                  {{data.item.Nama}}
                                  &mdash;
                                  <span
                                    class="text--secondary"
                                  >{{data.item.Kode}}</span>
                                </v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </template>
                        </v-autocomplete>
                      </Validate>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <Validate name="Rekening" rules="fully_required" #default="{ errors }">
                        <v-autocomplete
                          :error-messages="errors"
                          hide-details="auto"
                          v-model="item.Rekening"
                          :items="listRekening"
                          :loading="isRekeningLoading"
                          :search-input.sync="rekening.keyword"
                          :filter="filterRekening"
                          item-text="Nama"
                          item-value="IDRekening"
                          hide-no-data
                          label="Rekening"
                          placeholder="Pencarian rekening"
                          clearable
                          return-object
                        >
                          <template v-slot:selection="data">
                            <div class="text--secondary caption mb-n2 mt-2">{{data.item.Kode}}</div>
                            <v-list-item-title>{{data.item.Nama}}</v-list-item-title>
                          </template>
                          <template v-slot:item="data">
                            <template v-if="typeof data.item !== 'object'">
                              <v-list-item-content v-text="data.item"></v-list-item-content>
                            </template>
                            <template v-else>
                              <v-list-item-content>
                                <v-list-item-title class="py-0">
                                  {{data.item.Nama}}
                                  &mdash;
                                  <span
                                    class="text--secondary"
                                  >{{data.item.Kode}}</span>
                                </v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </template>
                        </v-autocomplete>
                      </Validate>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <Validate name="Uraian" rules="required" #default="{ errors }">
                        <v-text-field
                          :error-messages="errors"
                          hide-details="auto"
                          v-model="item.Uraian"
                          label="Uraian"
                          placeholder="Uraian"
                          type="text"
                        ></v-text-field>
                      </Validate>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <Validate
                        name="NominalSatuan"
                        rules="required|min_value:1"
                        #default="{ errors }"
                      >
                        <v-text-field
                          :error-messages="errors"
                          hide-details="auto"
                          v-model="item.NominalSatuan"
                          label="Harga Satuan"
                          placeholder="Harga Satuan"
                          type="number"
                        ></v-text-field>
                      </Validate>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6">
                      <Validate name="Volume" rules="required|min_value:1" #default="{ errors }">
                        <v-text-field
                          :error-messages="errors"
                          hide-details="auto"
                          v-model="item.Volume"
                          label="Volume"
                          placeholder="Volume"
                          type="number"
                        ></v-text-field>
                      </Validate>
                    </v-col>
                    <v-col cols="6">
                      <Validate name="Satuan" rules="required" #default="{ errors }">
                        <v-text-field
                          :error-messages="errors"
                          hide-details="auto"
                          v-model="item.Satuan"
                          label="Satuan"
                          placeholder="Satuan"
                          type="text"
                        ></v-text-field>
                      </Validate>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        disabled
                        hide-details="auto"
                        :value="$format.currency(item.Volume * item.NominalSatuan)"
                        label="Total"
                        placeholder="Total"
                        type="text"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn color="secondary" text @click="dialog = false">Batal</v-btn>
                  <v-spacer />
                  <v-btn color="primary" text @click="saveItem">Simpan</v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </ValidateAll>
        </v-dialog>
      </v-col>
    </v-row>
    <br />
    <v-row>
      <v-col cols="12" class="px-0 py-0">
        <v-divider />
        <v-data-table
          :headers="headers"
          :items="listAnggaran"
          :loading="loading"
          :loading-text="app.grid.loading"
          :no-data-text="app.grid.noData"
          :search="keyword"
          multi-sort
          hide-default-footer
          :items-per-page="-1"
        >
          <!-- custom field render -->
          <template v-slot:item="{ item, headers, index, isMobile }">
            <!-- first row is for penerimaan -->
            <template v-if="index == 0">
              <template v-for="(penerimaan, index) in item">
                <tr :key="'penerimaan-'+index">
                  <td
                    class="font-weight-black"
                    :class="{'v-data-table__mobile-table-row':isMobile}"
                  >{{penerimaan.Kode}}</td>
                  <td class="font-weight-black" colspan="4">{{penerimaan.Nama}}</td>
                  <td>
                    <v-chip color="success" small outlined>
                      <v-icon small left>mdi-wallet</v-icon>
                      {{sumBy(penerimaan.Detail, x => x.Pagu) | currency}}
                    </v-chip>
                  </td>
                  <td></td>
                  <td></td>
                  <td>
                    <v-btn-expand
                      v-model="expanded"
                      :isExpanded="expanded.includes('penerimaan-'+penerimaan.IDRekening)"
                      :expandedID="'penerimaan-'+penerimaan.IDRekening"
                    ></v-btn-expand>
                  </td>
                </tr>
                <template v-if="expanded.includes('penerimaan-'+penerimaan.IDRekening)">
                  <tr v-for="detail in penerimaan.Detail" :key="'penerimaan-detail-'+detail.ID">
                    <td></td>
                    <td>{{detail.Uraian}}</td>
                    <td>{{detail.Volume}}</td>
                    <td>{{detail.Satuan}}</td>
                    <td>{{detail.NominalSatuan | currency}}</td>
                    <td>{{detail.Pagu | currency}}</td>
                    <td>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <span dark v-on="on">{{$format.relativeUpdatedDate(detail)}}</span>
                        </template>
                        <span>{{$format.updatedDate(detail)}}</span>
                      </v-tooltip>
                    </td>
                    <td colspan="2" class="text-right">
                      <template v-if="!disabled">
                        <v-btn class="mr-4" icon color="blue" @click="editItem(detail)">
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                        <v-menu offset-y>
                          <template v-slot:activator="{ on }">
                            <v-btn icon v-on="on" :loading="detail.processing">
                              <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>
                          <v-list dense>
                            <v-list-item @click="deleteItem(detail)">
                              <v-list-item-icon>
                                <v-icon color="red">mdi-delete</v-icon>
                              </v-list-item-icon>

                              <v-list-item-content>
                                <v-list-item-title>Hapus</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </template>
                    </td>
                  </tr>
                </template>
              </template>
            </template>
            <!-- the rest is for belanja -->
            <template v-else>
              <tr :key="'belanja-program-'+index">
                <td class="font-weight-black">{{item.Kode}}</td>
                <td class="font-weight-black" colspan="4">{{item.Nama}}</td>
                <td class="font-weight-black">
                  <v-chip color="primary" small outlined>
                    <v-icon small left>mdi-cart</v-icon>
                    {{sumBy(item.Detail, x=> sumBy(x.Detail, y => sumBy(y.Detail, z => z.Pagu))) | currency}}
                  </v-chip>
                </td>
                <td></td>
                <td></td>
                <td></td>
              </tr>

              <template v-for="kegiatan in item.Detail">
                <tr :key="'belanja-kegiatan-'+kegiatan.IDKegiatan">
                  <td class="font-weight-black">{{kegiatan.Kode}}</td>
                  <td class="font-weight-black" colspan="4">{{kegiatan.Nama}}</td>
                  <td class="font-weight-black">
                    <v-chip color="primary" small outlined>
                      <v-icon small left>mdi-cart</v-icon>
                      {{sumBy(kegiatan.Detail, x => sumBy(x.Detail, y => y.Pagu)) | currency}}
                    </v-chip>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <template v-for="rekening in kegiatan.Detail">
                  <tr :key="'belanja-rekening-'+kegiatan.IDKegiatan+rekening.IDRekening">
                    <td>{{rekening.Kode}}</td>
                    <td colspan="4">{{rekening.Nama}}</td>
                    <td>{{sumBy(rekening.Detail, x => x.Pagu) | currency}}</td>
                    <td></td>
                    <td></td>
                    <td>
                      <v-btn-expand
                        v-model="expanded"
                        :isExpanded="expanded.includes('belanja-'+kegiatan.IDKegiatan+'-'+rekening.IDRekening)"
                        :expandedID="'belanja-'+kegiatan.IDKegiatan+'-'+rekening.IDRekening"
                      ></v-btn-expand>
                    </td>
                  </tr>

                  <template
                    v-if="expanded.includes('belanja-'+kegiatan.IDKegiatan+'-'+rekening.IDRekening)"
                  >
                    <template v-for="belanja in rekening.Detail">
                      <tr :key="belanja.uid">
                        <td></td>
                        <td>{{belanja.Uraian}}</td>
                        <td>{{belanja.Volume}}</td>
                        <td>{{belanja.Satuan}}</td>
                        <td>{{belanja.NominalSatuan | currency}}</td>
                        <td>{{belanja.Pagu | currency}}</td>
                        <td>
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <span dark v-on="on">{{$format.relativeUpdatedDate(belanja)}}</span>
                            </template>
                            <span>{{$format.updatedDate(belanja)}}</span>
                          </v-tooltip>
                        </td>
                        <td colspan="2" class="text-right">
                          <template v-if="!disabled">
                            <v-btn class="mr-4" icon color="blue" @click="editItem(belanja)">
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                            <v-menu offset-y>
                              <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" :loading="belanja.processing">
                                  <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                              </template>
                              <v-list dense>
                                <v-list-item @click="deleteItem(belanja)">
                                  <v-list-item-icon>
                                    <v-icon color="red">mdi-delete</v-icon>
                                  </v-list-item-icon>

                                  <v-list-item-content>
                                    <v-list-item-title>Hapus</v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </template>
                        </td>
                      </tr>
                    </template>
                  </template>
                </template>
              </template>
            </template>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </span>
</template>

<style lang="scss">
</style>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { clone, sumBy } from "lodash";

export default {
  name: "rincian-anggaran",
  components: {
    VBtnExpand: () =>
      import(/* webpackChunkName: "VBtnExpand" */ "@/components/VBtnExpand.vue")
  },
  props: {
    value: Array,
    loading: Boolean,
    disabled: Boolean
  },
  data: () => ({
    expanded: [],
    cache: {
      Jenis: "belanja",
      Program: {},
      Kegiatan: {},
      Rekening: {}
    },
    proto: {
      uid: "",
      Jenis: "belanja",
      IDRekening: "",
      Rekening: {},
      IDKegiatan: "",
      Kegiatan: {},
      IDProgram: "",
      Program: {},
      Pagu: 0,
      Volume: 0,
      Satuan: "",
      Uraian: "",
      NominalSatuan: 0,
      CreatedDate: null,
      LastUpdatedDate: null
    },
    dialog: false,
    rekening: {
      keyword: "",
      awaiting: false
    },
    keyword: "",
    item: {},
    items: [],
    headers: [
      {
        value: "Rekening.Kode",
        text: "Kode",
        sortable: false,
        width: "10%"
      },
      {
        value: "Uraian",
        text: "Uraian",
        sortable: false,
        width: "20%"
      },
      {
        value: "Volume",
        text: "Volume",
        sortable: false,
        width: "8%"
      },
      {
        value: "Satuan",
        text: "Satuan",
        sortable: false,
        width: "8%"
      },
      {
        value: "NominalSatuan",
        text: "Harga Satuan",
        sortable: false,
        width: "10%"
      },
      {
        value: "Total",
        text: "Total",
        sortable: false,
        width: "19%"
      },
      {
        value: "LastUpdatedDate",
        text: "Terakhir Diubah",
        sortable: false,
        width: "15%"
      },
      {
        value: "Actions",
        sortable: false,
        width: "15%"
      },
      {
        sortable: false,
        width: "5%"
      }
    ]
  }),
  computed: {
    ...mapState({
      app: state => state.app,
      list: state => state.list
    }),
    ...mapGetters("list", [
      "isRekeningLoading",
      "listRekeningBelanja",
      "listRekeningPenerimaan",
      "isKegiatanLoading",
      "isProgramLoading"
    ]),
    listRekening() {
      if (this.item.Jenis == "belanja") return this.listRekeningBelanja;
      return this.listRekeningPenerimaan;
    },
    isKegiatanEmpty() {
      return this.$util.isEmpty(this.item.Kegiatan);
    },
    isProgramEmpty() {
      return this.$util.isEmpty(this.item.Program);
    },
    listAnggaran() {
      let result = this.value.reduce(
        (result, d, i) => {
          if (i == 0) result.data.push([]);

          let programCacheKey = `p-${d.IDProgram}`,
            kegiatanCacheKey = `k-${d.IDProgram}-${d.IDKegiatan}`,
            rekeningCacheKey = `r-${d.IDProgram}-${d.IDKegiatan}-${d.IDRekening}`;

          let programIndex = result.cache[programCacheKey],
            kegiatanIndex = result.cache[kegiatanCacheKey],
            rekeningIndex = result.cache[rekeningCacheKey];

          if (!result.sum[programCacheKey]) result.sum[programCacheKey] = 0;
          if (!result.sum[kegiatanCacheKey]) result.sum[kegiatanCacheKey] = 0;
          if (!result.sum[rekeningCacheKey]) result.sum[rekeningCacheKey] = 0;
          if (d.Jenis == "belanja") {
            if (programIndex >= 0) {
              if (kegiatanIndex >= 0) {
                if (rekeningIndex >= 0) {
                  result.data[programIndex].Detail[kegiatanIndex].Detail[
                    rekeningIndex
                  ].Detail.push(d);
                } else {
                  result.cache[rekeningCacheKey] =
                    result.data[programIndex].Detail[
                      kegiatanIndex
                    ].Detail.length;

                  result.data[programIndex].Detail[kegiatanIndex].Detail.push({
                    IDRekening: d.IDRekening,
                    Kode: d.Rekening ? d.Rekening.Kode : "-",
                    Nama: d.Rekening ? d.Rekening.Nama : "-",
                    Detail: [d]
                  });
                }
              } else {
                result.cache[kegiatanCacheKey] =
                  result.data[programIndex].Detail.length;
                result.cache[rekeningCacheKey] = 0;

                result.data[programIndex].Detail.push({
                  IDKegiatan: d.IDKegiatan,
                  Kode: d.Kegiatan ? d.Kegiatan.Kode : "-",
                  Nama: d.Kegiatan ? d.Kegiatan.Nama : "-",
                  Detail: [
                    {
                      IDRekening: d.IDRekening,
                      Kode: d.Rekening ? d.Rekening.Kode : "-",
                      Nama: d.Rekening ? d.Rekening.Nama : "-",
                      Detail: [d]
                    }
                  ]
                });
              }
            } else {
              // storing result.cache key
              result.cache[programCacheKey] = result.data.length;
              result.cache[kegiatanCacheKey] = 0;
              result.cache[rekeningCacheKey] = 0;

              result.data.push({
                IDProgram: d.IDProgram,
                Kode: d.Program ? d.Program.Kode : "-",
                Nama: d.Program ? d.Program.Nama : "-",
                Detail: [
                  {
                    IDKegiatan: d.IDKegiatan,
                    Kode: d.Kegiatan ? d.Kegiatan.Kode : "-",
                    Nama: d.Kegiatan ? d.Kegiatan.Nama : "-",
                    Detail: [
                      {
                        IDRekening: d.IDRekening,
                        Kode: d.Rekening ? d.Rekening.Kode : "-",
                        Nama: d.Rekening ? d.Rekening.Nama : "-",
                        Detail: [d]
                      }
                    ]
                  }
                ]
              });
            }
          } else {
            if (rekeningIndex >= 0) {
              result.data[0][rekeningIndex].Detail.push(d);
            } else {
              result.cache[rekeningCacheKey] = result.data[0].length;
              result.data[0].push({
                IDRekening: d.IDRekening,
                Kode: d.Rekening ? d.Rekening.Kode : "-",
                Nama: d.Rekening ? d.Rekening.Nama : "-",
                Detail: [d]
              });
            }
          }
          return result;
        },
        { data: [], cache: {}, sum: {} }
      );

      return result.data || [];
    }
  },
  methods: {
    ...mapActions("list", ["refreshKegiatan"]),
    addItem() {
      if (this.$refs.form) this.$refs.form.reset();
      this.item = Object.assign({}, this.proto, this.getCache());
      this.item.uid = this.$util.uid();
      this.dialog = true;
    },
    editItem(item) {
      if (this.$refs.form) this.$refs.form.reset();
      this.item = clone(this.preProcessItem(item));
      this.dialog = true;
    },
    async saveItem() {
      const valid = await this.$refs.form.validate();
      if (!valid) return;

      if (this.item.ID) this.item.LastUpdatedDate = new Date();
      else this.item.CreatedDate = new Date();

      this.item = this.preProcessItem(this.item);
      let index = this.value.findIndex(x => x.uid == this.item.uid);

      // store cache to prevent re-selecting for next input
      // this only for Jenis == belanja
      this.setCache(this.item);

      if (index == -1) this.value.push(this.item);
      else this.$set(this.value, index, this.item);
      this.dialog = false;

      let expandedID =
        this.item.Jenis == "penerimaan"
          ? `penerimaan-${this.item.IDRekening}`
          : `belanja-${this.item.IDKegiatan}-${this.item.IDRekening}`;
      if (this.expanded.indexOf(expandedID) == -1)
        this.expanded.push(expandedID);

      // this.$vuetify.goTo("", )
    },
    setCache(item) {
      if (item.Jenis == "belanja") {
        this.cache.Jenis = item.Jenis;
        this.cache.Rekening = item.Rekening;
        this.cache.Program = item.Program;
        this.cache.Kegiatan = item.Kegiatan;
      }
    },
    getCache() {
      if (this.cache.Jenis == "belanja") {
        return this.cache;
      }
      return {};
    },
    preProcessItem(item) {
      item.Volume = parseFloat(item.Volume);
      item.NominalSatuan = parseFloat(item.NominalSatuan);
      item.Pagu = item.Volume * item.NominalSatuan;
      return item;
    },
    async deleteItem(item) {
      const confirmation = await this.$dialog.confirm({
        text: "Apakah anda yakin menghapus data ?"
      });
      if (confirmation) {
        let index = this.value.findIndex(x => x.uid == item.uid);
        if (index > -1) this.value.splice(index, 1);
      }
    },
    filterRekening(item, queryText) {
      const nama = item.Nama.toLowerCase();
      const kode = item.Kode.toLowerCase();
      const searchText = queryText.toLowerCase();

      return nama.indexOf(searchText) > -1 || kode.indexOf(searchText) > -1;
    },
    filterKegiatan(item, queryText) {
      const nama = item.Nama.toLowerCase();
      const kode = item.Kode.toLowerCase();
      const searchText = queryText.toLowerCase();

      return nama.indexOf(searchText) > -1 || kode.indexOf(searchText) > -1;
    },
    filterProgram(item, queryText) {
      const nama = item.Nama.toLowerCase();
      const kode = item.Kode.toLowerCase();
      const searchText = queryText.toLowerCase();

      return nama.indexOf(searchText) > -1 || kode.indexOf(searchText) > -1;
    },
    changeJenisTransaksi() {
      this.item.Rekening = {};
      this.item.Program = {};
      this.item.Kegiatan = {};
    },
    changeProgram() {
      this.item.Kegiatan = {};
    },
    sumBy(d, fn) {
      return sumBy(d, fn);
    },
    key(item) {
      return `key-${item.IDProgram || ""}-${item.IDKegiatan ||
        ""}-${item.IDRekening || ""}`;
    }
  },
  watch: {
    "item.Rekening"(v) {
      if (!this.$util.isEmpty(v)) this.item.IDRekening = v.IDRekening;
      else this.item.IDRekening = "";
    },
    "item.Program"(v) {
      if (!this.$util.isEmpty(v)) {
        this.item.IDProgram = v.IDProgram;
        this.refreshKegiatan(v.IDProgram);
      } else this.item.IDProgram = "";
    },
    "item.Kegiatan"(v) {
      if (!this.$util.isEmpty(v)) this.item.IDKegiatan = v.IDKegiatan;
      else this.item.IDKegiatan = "";
    }
  }
};
</script>

